import React, { useEffect, useState } from 'react'
import { InlineWidget, PopupWidget } from "react-calendly";

function CalendlyComponent(props) {
    const { url } = props;
    const [userDetails, setUserDetails] = useState();

    useEffect(() => {
      let userDetailss = localStorage.getItem('userDetails');
      if (userDetailss) {
        setUserDetails(JSON.parse(userDetailss))
      }
      console.log("User detailssss",userDetails)
    }, []);

    const pageSettings={
        backgroundColor: 'ffffff',
        hideEventTypeDetails: false,
        hideLandingPageDetails: false,
        primaryColor: '00a2ff',
        textColor: '4d5055'
      }


      const prefill={
        email: userDetails?.email, 
        name: userDetails?.firstName + " " + userDetails?.middleName + " " + userDetails?.lastName,
        smsReminderNumber: userDetails?.mobile 
        // email: 'mahendra@gmail.com', 
        // name: 'Mahendra singh ',
        // smsReminderNumber: '+1234567890' 
     
      }


    return (
        <InlineWidget 
        pageSettings={pageSettings}
        prefill={prefill}
        url={url}
        />
    
    
        // to use button for popup
        // <PopupButton
        //   url="https://calendly.com/your-calendly-username"
        //   rootElement={document.getElementById('root')}
        //   text="Book a Doubt-Clearing Session"
        // />
    
    //     <PopupWidget
    //     url="https://calendly.com/your-calendly-username"
    //     rootElement={document.getElementById('root')}
    //     text="Schedule a session"
    //     textColor="#ffffff"
    //     color="#00a2ff"
    //   />
      )
}
export default CalendlyComponent